var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { postDataParse } from "./common";
export var responseErrorSgmReport = function (error) {
    var _a;
    try {
        var _b = error.config, method = _b.method, headers = _b.headers;
        var responseData = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
        var logMsg = {
            request: null,
            functionId: "",
            header: headers,
            response: responseData,
        };
        if ((method === null || method === void 0 ? void 0 : method.toUpperCase()) === "GET" && error.config.params) {
            logMsg.functionId = error.config.params.functionId || "";
            logMsg.request = error.config.params.body;
        }
        if ((method === null || method === void 0 ? void 0 : method.toUpperCase()) === "POST" && error.config.data) {
            var parseData = postDataParse(error.config.data);
            logMsg.functionId = parseData.functionId;
            logMsg.request = parseData.body;
        }
        if (Object.prototype.hasOwnProperty.call(window, "__sgm__")) {
            /* eslint no-underscore-dangle: "off" */
            window.__sgm__.custom({
                type: "1",
                code: "request error catch",
                msg: __assign({ error: error.message }, logMsg),
            });
            return Promise.reject(error);
        }
    }
    catch (catchError) {
        console.log("responseErrorSgmReport error");
    }
    return Promise.reject(error);
};
